import { useParams, useSearchParams } from 'react-router-dom';
import BookingComponent from '../components/BookingComponent';
import SeoMeta from '../components/SeoMeta';

/**
 * Human-friendly aliases for booking calendars.
 * Maps a readable slug (used in the URL) to the real booking config token.
 * Example: /booking/15-min  →  resolves to the 15-minute meeting calendar.
 */
const TOKEN_ALIASES = {
  '15-min': '759a4c28-37de-4174-9c5f-08b1f4e40fda',
};

/**
 * BookingPage — wrapper page for the embeddable BookingComponent.
 * Route: /booking/:token
 * The :token segment accepts either a raw config token or a friendly alias
 * defined in TOKEN_ALIASES (e.g. "15-min").
 * Optional query param: ?lang=en (defaults to 'es')
 */
const BookingPage = () => {
  const { token: tokenParam } = useParams();
  const token = TOKEN_ALIASES[tokenParam] || tokenParam;
  const [searchParams] = useSearchParams();
  const locale = searchParams.get('lang') || 'es';
  const prefillName = searchParams.get('name') || '';
  const prefillEmail = searchParams.get('email') || '';
  const prefillSubject = searchParams.get('subject') || '';
  const isSpanish = locale === 'es';

  return (
    <>
      <SeoMeta
        title={isSpanish ? 'Reserva tu reunión con BlueCMR' : 'Book a meeting with BlueCMR'}
        description={isSpanish ? 'Selecciona fecha y hora. El equipo de BlueCMR te enviará el enlace de la reunión.' : 'Select a date and time. The BlueCMR team will send you the meeting link.'}
        noindex
      />
      <div className="min-h-[60vh] py-12 px-4">
        <div className="max-w-2xl mx-auto text-center mb-8">
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">
            {isSpanish ? 'Reserva tu reunión con BlueCMR' : 'Book a meeting with BlueCMR'}
          </h1>
          <p className="text-gray-600 leading-relaxed">
            {isSpanish
              ? 'Selecciona la fecha y hora que mejor te convenga. El equipo de BlueCMR revisará tu solicitud y te enviará una convocatoria con el enlace de la reunión.'
              : 'Select the date and time that works best for you. The BlueCMR team will review your request and send you a calendar invite with the meeting link.'}
          </p>
        </div>
        <div className="flex justify-center">
          <BookingComponent
            bookingToken={token}
            locale={locale}
            prefillName={prefillName}
            prefillEmail={prefillEmail}
            prefillSubject={prefillSubject}
          />
        </div>
      </div>
    </>
  );
};

export default BookingPage;
